import { useState, useMemo } from "react";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

const DataSelector = ({ data = [] }) => {
  const [zone, setZone] = useState("");
  const [areaName, setAreaName] = useState("");
  const [date, setDate] = useState("");

  // Extract unique zones and areaNames from data
  const zones = useMemo(() => [...new Set(data.map((d) => d.zone))], [data]);
  const areaNames = useMemo(() => [...new Set(data.map((d) => d.areaName))], [data]);

  // Filtered data based on selected filters
  const filteredData = useMemo(() => {
    return data.filter((d) => {
      const matchZone = !zone || d.zone === zone;
      const matchArea = !areaName || d.areaName === areaName;
      const matchDate = !date || (d.createdAt && new Date(d.createdAt).toISOString().slice(0, 10) === date);
      return matchZone && matchArea && matchDate;
    });
  }, [data, zone, areaName, date]);

  // Download Excel
  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, "ReportData.xlsx");
  };

  return (
    <div className="w-full bg-white shadow-md rounded-lg p-5 space-y-4">

      {/* Zone Select */}
      <div>
        <label className="block text-gray-600 text-sm font-medium mb-1">Zon</label>
        <select
          value={zone}
          onChange={(e) => setZone(e.target.value)}
          className="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-200 focus:outline-none"
        >
          <option value="">Sila Pilih</option>
          {zones.map((z) => (
            <option key={z} value={z}>{z}</option>
          ))}
        </select>
      </div>

      {/* AreaName Select */}
      <div>
        <label className="block text-gray-600 text-sm font-medium mb-1">Kawasan (Area)</label>
        <select
          value={areaName}
          onChange={(e) => setAreaName(e.target.value)}
          className="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-200 focus:outline-none"
        >
          <option value="">Sila Pilih</option>
          {areaNames.map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>

      {/* Date Picker */}
      <div>
        <label className="block text-gray-600 text-sm font-medium mb-1">Tarikh (Date)</label>
        <div className="flex items-center border rounded-md px-3 py-2 gap-2">
          <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-500" />
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="w-full focus:outline-none text-gray-700"
          />
        </div>
      </div>

      {/* Download Button */}
      <div className="flex justify-end">
        <button
          onClick={downloadExcel}
          className="w-64 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 flex items-center justify-center gap-2"
        >
          <FontAwesomeIcon icon={faDownload} />
          Muat Turun (Download Excel)
        </button>
      </div>

      {/* Optional: Display number of filtered records */}
      <p className="text-sm text-gray-500 mt-2">
        Showing {filteredData.length} record(s)
      </p>
    </div>
  );
};

export default DataSelector;
